import React from "react";
import ReactDOM from "react-dom";

import { IImage } from "types";
import { GalleryModal } from "components";
import { getRenderRoot, RenderRoot } from "utils";

const imageBlocks = document.querySelectorAll<HTMLElement>("[data-image]");
const MODAL_ROOT = getRenderRoot(RenderRoot.modal);

imageBlocks.forEach((imageBlock) => {
  const imageInfo = imageBlock.dataset.image;
  imageBlock.dataset.image = ""; // cleanup

  // render fulllscreen image in modal on image click
  imageBlock.addEventListener("click", () => {
    if (!imageInfo) return;

    const image: IImage = JSON.parse(imageInfo);

    ReactDOM.render(<GalleryModal images={[image]} />, MODAL_ROOT);
  });
});

export {};
